// utils/dateUtils.js

export const getWeekRange = (date = new Date()) => {
  const current = new Date(date);
  const day = current.getDay();
  const diff = current.getDate() - day + (day === 0 ? -6 : 1);
  
  const monday = new Date(current.setDate(diff));
  const friday = new Date(monday);
  friday.setDate(monday.getDate() + 4);
  
  return {
    start: monday,
    end: friday,
    days: Array.from({ length: 5 }, (_, i) => {
      const day = new Date(monday);
      day.setDate(monday.getDate() + i);
      return day;
    })
  };
};

export const formatShiftTime = (start, end) => {
  const startTime = new Date(start).toLocaleTimeString([], { 
    hour: '2-digit', 
    minute: '2-digit' 
  });
  const endTime = new Date(end).toLocaleTimeString([], { 
    hour: '2-digit', 
    minute: '2-digit' 
  });
  return `${startTime} - ${endTime}`;
};

export const isOverlapping = (existingShifts, newShift) => {
  const newStart = new Date(newShift.startDateTime);
  const newEnd = new Date(newShift.endDateTime);
  
  return existingShifts.some(existing => {
    const existingStart = new Date(existing.startDateTime);
    const existingEnd = new Date(existing.endDateTime);
    
    return (
      (newStart >= existingStart && newStart < existingEnd) ||
      (newEnd > existingStart && newEnd <= existingEnd) ||
      (newStart <= existingStart && newEnd >= existingEnd)
    );
  });
};


export const getLocalDateString = (dateTimeString) => {
  if (!dateTimeString) return '';
  
  const date = new Date(dateTimeString);
  
  // Get local date components
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};

export const getLocalDateFromUTC = (utcDateTimeString) => {
  if (!utcDateTimeString) return null;
  
  // Parse UTC datetime
  const utcDate = new Date(utcDateTimeString);
  
  // Convert to local date
  return new Date(
    utcDate.getUTCFullYear(),
    utcDate.getUTCMonth(),
    utcDate.getUTCDate(),
    utcDate.getUTCHours(),
    utcDate.getUTCMinutes(),
    utcDate.getUTCSeconds()
  );
};